









import Vue from "vue";
import { SearchResponseDocument } from "search-api-client/lib/models";
import { formatDateMonthYear } from "@/common/date";
export default Vue.extend({
  name: "ResultResource",
  props: {
    result: {
      type: Object as () => SearchResponseDocument,
      required: true,
      default: []
    }
  },
  methods: {
    formatDate(input: string) {
      return formatDateMonthYear(input);
    }
  }
});
